import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { MenuIcon } from "lucide-react";

import { Button } from "@/components/ui/button";
import { Menu } from "@/components/sidebar/menu";
import { FeedbackModal } from "@/components/modals/feedback-modal";
import {
  Sheet,
  SheetHeader,
  SheetContent,
  SheetTrigger,
  SheetTitle,
} from "@/components/ui/sheet";

export function SheetMenu() {
  const [open, setOpen] = useState(false);
  const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

  return (
    <>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger className="lg:hidden" asChild>
          <Button className="h-8" variant="outline" size="icon">
            <MenuIcon size={20} />
          </Button>
        </SheetTrigger>
        <SheetContent className="sm:w-72 px-3 h-full flex flex-col" side="left">
          <SheetHeader>
            <Button
              className="flex justify-center items-center pb-2 pt-1"
              variant="link"
              asChild
            >
              <Link
                to="/portfolio"
                search={{ tab: "dashboard" }}
                className="flex items-center gap-2"
              >
                <img
                  src="/wealthscale_light.svg"
                  alt="WealthScale Logo"
                  width={32}
                  height={32}
                  className="mr-1 block dark:hidden"
                />
                <img
                  src="/wealthscale_dark.svg"
                  alt="WealthScale Logo"
                  width={32}
                  height={32}
                  className="mr-1 hidden dark:block"
                />
                <SheetTitle className="font-bold text-lg">WealthScale</SheetTitle>
              </Link>
            </Button>
          </SheetHeader>
          <Menu
            isOpen
            onItemClick={() => setOpen(false)}
            onFeedbackClick={() => setIsFeedbackOpen(true)}
          />
        </SheetContent>
      </Sheet>
      <FeedbackModal open={isFeedbackOpen} onOpenChange={setIsFeedbackOpen} />
    </>
  );
}
